import Loader from '../../../Loader'
import { CommentsBlockPreview } from './CommentsBlockPreview'

/** @param {import('./ReportBlockComments.types').ReportBlockCommentsProps} props */
export const ReportBlockComments = ({ content, config, loading = false }) => {
  if (loading) return <Loader loading={loading} />

  if (content) {
    return <CommentsBlockPreview title={config.title} dateRange={{ from: config.from, to: config.to }} criteriaComments={content?.criteriaComments || []} />
  }

  return (
    <section>
      <h2>Preview</h2>
      <p>Once you select options from the left, a preview will show here</p>
    </section>
  )
}
